import { Chip, Typography } from "@mui/material";
import { useScrapEyeMetadata } from "src/contexts/scrapEyeMetadata";
import { pickAreaColorFromIndex } from "src/utils/areaColor";

export const AreaChip = ({
  area,
  label,
  selected,
  onClick,
}: {
  area: string;
  label: string;
  selected: boolean;
  onClick: () => void;
}) => {
  const { available_areas: availableAreas } = useScrapEyeMetadata();
  const color = pickAreaColorFromIndex(availableAreas.indexOf(area));

  return (
    <Chip
      label={
        <Typography
          variant="body2"
          sx={{
            fontWeight: selected ? 600 : 400,
            color: "text.primary",
          }}
        >
          {label}
        </Typography>
      }
      onClick={onClick}
      sx={{
        backgroundColor: selected ? color : `${color}40`,
        borderColor: color,
        borderWidth: 2,
        borderStyle: "solid",
        cursor: "pointer",
        transition: "all 0.2s ease",
        "&:hover": {
          backgroundColor: selected ? color : `${color}80`,
          transform: "scale(1.05)",
        },
      }}
    />
  );
};
